<template>
  <div id="tab-license-add-others">
    <form>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-full license-col-min-width">
          <vs-input
            class="w-full"
            label="免許/資格名"
            v-model="inputForm.name"
            v-validate="'required|max:32'"
            name="name"
            data-vv-as="免許/資格名"
          />
          <span class="text-danger text-sm" v-show="errors.has('name')">{{
            errors.first("name")
          }}</span>
        </div>
        <div class="vx-col md:w-1/4 w-full license-col-min-width">
          <label class="vs-input--label">有効期限</label>
          <datepicker
            name="selectExpirationDate"
            :language="ja"
            :format="formatter"
            :typeable="true"
            placeholder="日付を選択してください"
            v-model="inputForm.expirationDate"
            v-validate="'required'"
            data-vv-as="有効期限"
            :disabled-dates="disabledDates"
            ref="datePickerExpirationDate"
          ></datepicker>
          <span
            class="text-danger text-sm"
            v-show="errors.has('selectExpirationDate')"
            >{{ errors.first("selectExpirationDate") }}</span
          >
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 mt-8 mb-8 w-full license-col-min-width">
          <input-image
            :label="'免許証/資格の画像'"
            ref="inputImage"
            @onSetImage="onSetImage"
          ></input-image>
        </div>
        <div class="vx-col md:w-1/4 w-full input-form-memo license-col-min-width">
          <label class="vs-input--label">メモ</label>
          <vs-textarea v-model="inputForm.memo" width="100%" height="200px"/>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import Datepicker from "vuejs-datepicker";
import LicenseMixin from "@/mixins/LicenseMixin";
import DatepickerMixin from "@/mixins/DatepickerMixin";
import InputImage from "@/components/formElemens/input/InputImage";
import { FileUtil } from "@/utils";

const { mapActions } = createNamespacedHelpers("enterpriseLicenseAdd");

export default {
  data() {
    return {
      inputForm: {
        name: null,
        licenseTypeId: null,
        expirationDate: null,
        memo: null,
      },
      disabledDates: {
        to: new Date(),
      }
    };
  },
  components: {
    Datepicker,
    InputImage
  },
  mixins: [LicenseMixin, DatepickerMixin],
  methods: {
    ...mapActions(["setInputForm", "setPictureSrc", "clearPictureSrc"]),

    onSetImage(evt) {
      let blob = FileUtil.toBlob(evt.src, evt.type);
      this.setPictureSrc(blob);
    },

    onClearImage() {
      this.clearPictureSrc();
    },

    async validate() {
      let result = await this.$validator.validateAll();
      if (result) {
        let payload = {
          name: this.inputForm.name,
          license_type_id: this.marineOthersLicenseOptions[0].value,
          expiration_date: this.inputForm.expirationDate,
          memo: this.inputForm.memo,
        };
        await this.setInputForm(payload);
      }
      return result;
    },

    clean() {
      this.inputForm.name = null;
      this.inputForm.licenseTypeId = null;
      this.inputForm.expirationDate = null;
      this.inputForm.memo = null;
    }
  },
  mounted() {
    this.customizeExpirationDateElement(this.$refs.datePickerExpirationDate.$el);
  },
};
</script>

<style lang="scss">
#tab-license-add-others {
  .license-col-min-width {
    min-width: 220px;
  }
  .vs-input {
    margin-top: 0px;
  }
  .input-form-memo {
    padding-top: 2rem;
    .vs-con-textarea {
      margin-top: 0.6rem;
    }
    .vs-textarea {
      height: 200px;
    }
  }
}
</style>
